import { Component, Inject, OnInit } from "@angular/core";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";
import { Router, UrlTree } from "@angular/router";
import parseSubscriptionAsStatus from "@app/_helpers/parseSubscriptionAsStatus";
import { AppService } from "@app/app.service";
import { UserSettingsQuery } from "@timeghost/web-api";

@Component({
	selector: "app-workspace-users-limitations-warn-dialog",
	templateUrl: "./workspace-users-limitations-warn-dialog.component.html",
	styleUrls: ["./workspace-users-limitations-warn-dialog.component.scss"],
})
export class WorkspaceUsersLimitationsWarnDialogComponent implements OnInit {
	constructor(
		@Inject(MAT_DIALOG_DATA)
		private data: { upgradeUrl: UrlTree; onCancel?: () => void; onUpgrade?: () => void },
		private appService: AppService,
		private router: Router,
		private userSettingsQuery: UserSettingsQuery,
		private ref: MatDialogRef<WorkspaceUsersLimitationsWarnDialogComponent>
	) {}

	ngOnInit() {
		this.ref.updateSize("430px");
		this.ref.addPanelClass("mat-dialog-panel-full");
	}
	status$ = this.userSettingsQuery.select((x) => parseSubscriptionAsStatus(x.workspace, x));
	async openUpgrade() {
		if (this.appService.isTeams()) {
			return;
		}
		if (this.data.onUpgrade) {
			this.data.onUpgrade();
		}
		await this.router.navigateByUrl(this.data.upgradeUrl.toString());
		this.ref.close();
	}
	onCancel() {
		this.ref.close();
		if (this.data.onCancel) {
			this.data.onCancel();
		}
	}
}
